import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { GetHealthcareExcelExport } from "../../../services/api/dashboard-api";
import { Accordion, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import DropdownUpArrow from "../../../assets/icons/Icon-Dashboard-ChevronUp-32px-Blue.svg";
import DropdownArrow from "../../../assets/icons/Icon-Dashboard-ChevronDown-32px-Blue.svg";
import DashboardEdit from "../../../assets/icons/Icon-Dashboard-Edit-32px-Blue.svg";
import DashboardExpand from "../../../assets/icons/Icon-Dashboard-Expand-32px-Blue.svg";
import DashboardExport from "../../../assets/icons/Icon-Dashboard-Export-32px-Blue.svg";
import {
  onHandleHover,
  onHandleHoverDone,
  getSetToggledHealthcare,
  getDateColor,
  renderTableHealthcare,
  getCollapsedStatus,
  toggleAccordion,
  useSortableData,
  toggleAccordionOpen,
  NameAndBadge,
} from "../../new-dashboard/dashboard-util/dashboard-utils";
import "../dashboard-healthcare/dashboard-healthcare.scss";
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../assets/icons/ArrowHover.svg";
import ExpandCollapseButton from "../../../components/expand-collapse-button/expand-collapse-button";
import { Link } from "react-router-dom";
import { newDashboardMap } from "../new-dashboard-mapper";
import { LoginContext } from "../../../services/api/authentication-api";
import { FluentAvatar } from "../../../components/FluentUI/Fluent-Avatar";

// Custom Healthcare Dashboard Widget
const DashboardHealthcare = (props) => {
  const [members, setMembers] = useState(props.items ? props.items : null);
  const [toggled, setToggled] = useState([]);
  const [show, setShow] = useState(false);
  const [showDeals, setShowDeals] = useState(false);
  const [seletedMember, setSeletedMember] = useState(null);
  const [accordionId] = useState("healthcare-accordion");
  const [collapsed, setCollapsed] = useState(true);
  const [juniorBankerView, setJuniorBankerView] = useState(false);
  const currentUser = useContext(LoginContext);

  useEffect(() => {
    if (props.items) setMembers(props.items);
  }, [props]);

  useEffect(() => {
    if (members) setToggled(getSetToggledHealthcare(members));
    healthJuniorBankerView();
  }, [members]);

  const showModal = (m) => {
    setShow(true);
    setSeletedMember(m);
  };

  const showDealsModal = (m) => {
    setShowDeals(true);
    setSeletedMember(m);
  };

  const healthJuniorBankerView = () => {
    if(members?.length === 1 && members[0]?.UserID === currentUser.userID){
      setJuniorBankerView(true);
      toggleAccordionOpen(accordionId + "-" + members[0]?.UserID);
    }
  }

  const onHide = () => setShow(false);

  const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

  const isValidPTO = (table) => {
    let week1 = [];
    let week2 = [];
    let quarter = [];
    let pto = [];

    for (let i = 0; i < table.length; i += 4) {
      week1.push(table[i]);
      week2.push(table[i + 1]);
      quarter.push(table[i + 2]);
      pto.push(table[i + 3]);
    }

    if(!isPTOData(week1) && !isPTOData(week2) && !isPTOData(quarter) && !isPTOData(pto)){
      return false;
    }
    else {
      return true;
    }
  }

  const isPTOData = (ptoTable) => {
    let result = false;

    for (let i = 0; i < ptoTable.length; i++) {
      if(result){
        continue;
      }
      if(ptoTable[i]?.Columns != null && ptoTable[i]?.Rows != null){
        result = true;
      }
    }
    return result;
  }

  const redirectToEdit = (m) => {
    return (    
      m.AllowDealsEdit
      ?
      <div>
        <Link to={`/tasks/edit/std/${m.DealsTaskId}`} target="_blank"  rel='noopener noreferrer'>
          <img
            disabled ={!m.AllowDealsEdit}
            alt="dropdown-arrow"
            src={DashboardEdit}
          />
        </Link>
      </div>
      :
      <img
        disabled
        alt="dropdown-arrow"
        src={DashboardEdit}
      />
    )
  }

  const renderTableVacation = (table) => {
    let result = [];
    let week1 = [];
    let week2 = [];
    let quarter = [];
    let pto = [];

    for (let i = 0; i < table.length; i += 4) {
      week1.push(table[i]);
      week2.push(table[i + 1]);
      quarter.push(table[i + 2]);
      pto.push(table[i + 3]);
    }

    if (!isPTOData(week1) && !isPTOData(week2) && !isPTOData(quarter) && !isPTOData(pto)) {
      result = (
        <div>
          <Modal.Title className="popup-healthcare-title ml-4 mb-4">
            No Upcoming PTO data
          </Modal.Title>
        </div>
      );
    } else {
      result = (
        <div>
          {
            isPTOData(week1) && (
              <Modal.Title className="popup-healthcare-title ml-4 mb-4">
                Mandatory Week 1 (5 days)
              </Modal.Title>
            )
          }
          {renderTableHealthcare(week1, false)}

          {
            isPTOData(week2) && (
              <Modal.Title className="popup-healthcare-title ml-4 mb-4">
                Mandatory Week 2 (5 days)
              </Modal.Title>
            )
          }
          {renderTableHealthcare(week2, false)}

          {
            isPTOData(quarter) && (
              <Modal.Title className="popup-healthcare-title ml-4 mb-4">
                Quarterly Protected 3-Day Weekend (Q1)
              </Modal.Title>
            )
          }
          {renderTableHealthcare(quarter, false)}

          {
            isPTOData(pto) && (
                <Modal.Title className="popup-healthcare-title ml-4 mb-4">
                  Other PTO
                </Modal.Title>
              )
          }
          {renderTableHealthcare(pto, false)}
        </div>
      );

    }
    return result;
  };

  if (items != null && items.length > 0) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <th className="DashboardTableTitle">
                  Project, Deals, and Vacation Tracker
                  <div className="DashboardTableHeaderButtons">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Export Data</Tooltip>}
                   >
                      <img src = {DashboardExport} onClick={GetHealthcareExcelExport} alt="Export Healthcare" />
                    </OverlayTrigger>
                    {!juniorBankerView &&<ExpandCollapseButton accordionId={accordionId} collapsed={collapsed} setCollapsed={setCollapsed} toggled={toggled} setToggled={setToggled}/>}
                  </div>
                  <p className="subDepartmentTitle">Healthcare</p>
                </th>
              </tr>
            </thead>

            {/* Project and Deals table  */}
            <div className={newDashboardMap.HC.user.includes(props.currSubDepartment) ? `no-scroll-dashboard`:`scrollable-dashboard`}>
            <Accordion>
                <Card className="MemberTableBodyWrapper sticky-header-dashboard">
                  <thead className="MemberTableColumnHeader">
                    <tr className="MemberTableColumnTitles">
                      <th className="col-md-2 textEllipsis headerSorted">
                      <div onClick={() => requestSort('Name')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted"> NAME</p>
                              </div>
                              {
                                getArrowDirectionFor("Name", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Name", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Name") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2 textEllipsis headerSorted">
                      <div onClick={() => requestSort('LevelIntensity')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">ACTIVITY LEVEL</p>
                              </div>
                              {
                                getArrowDirectionFor("LevelIntensity", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("LevelIntensity", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("LevelIntensity") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2 textEllipsis headerSorted">
                      <div onClick={() => requestSort('NextProtectedWeekend')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">NEXT PROTECTED WEEKEND</p>
                              </div>
                              {
                                getArrowDirectionFor("NextProtectedWeekend", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("NextProtectedWeekend", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("NextProtectedWeekend") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2 pr-5 textEllipsis headerSorted">
                      <div onClick={() => requestSort('UpcomingPTO')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">UPCOMING PTO</p>
                              </div>
                              {
                                getArrowDirectionFor("UpcomingPTO", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("UpcomingPTO", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("UpcomingPTO") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2 textEllipsis headerSorted">
                      <div onClick={() => requestSort('LastUpdated')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">LAST UPDATED DATE</p>
                              </div>
                              {
                                getArrowDirectionFor("LastUpdated", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("LastUpdated", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("LastUpdated") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>

                      </th>
                      <th className="col-md-2"></th>
                    </tr>
                  </thead>
                </Card>
                <table>
                  <tbody className="healthcare-tablebody">
                    {items &&
                      items.map((m) => {
                        return (
                          <tr key={m?.UserID} className="healthcare-table-row">
                            <Card>
                              <div className="MemberTableBody overrideDashboardMargin row">
                                <td className="col-md-2 mt-2 dashboard-username">
                                  <FluentAvatar size={32} name={m?.Name} className="task-member-user"/>                                
                                  {
                                    juniorBankerView
                                    ?
                                      <NameAndBadge name={m.Name} />
                                    :
                                      <span className="Memberoverlaybutton mt-1 pl-1">
                                        {m.Name}
                                      </span>
                                  }
                                </td>
                                <td className="col-md-2 mt-2">
                                  {m.LevelIntensity}
                                </td>
                                <td
                                  onMouseLeave={(e) => {if(isValidPTO(m.TableVacation)) onHandleHoverDone(e)}}
                                  onMouseEnter={(e) => {if(isValidPTO(m.TableVacation)) onHandleHover(e)}}
                                  onClick={() => {if(isValidPTO(m.TableVacation)) showModal(m)}}
                                  className={isValidPTO(m.TableVacation) ? "col-md-2 mt-2 healthcare-dates" : "col-md-2 mt-2 healthcare-dates-disabled"}
                                  style={{
                                    color: getDateColor(
                                      m.NextProtectedWeekend[0]
                                    ),
                                  }}
                                >
                                  {m.NextProtectedWeekend[1]} -{" "}
                                  {m.NextProtectedWeekend[2]}
                                </td>
                                <td
                                  onMouseLeave={(e) => {if(isValidPTO(m.TableVacation)) onHandleHoverDone(e)}}
                                  onMouseEnter={(e) => {if(isValidPTO(m.TableVacation)) onHandleHover(e)}}
                                  onClick={() => {if(isValidPTO(m.TableVacation)) showModal(m)}}
                                  className={isValidPTO(m.TableVacation) ? "col-md-2 mt-2 healthcare-dates" : "col-md-2 mt-2 healthcare-dates-disabled"}
                                  style={{
                                    color: getDateColor(m.UpcomingPTO[0]),
                                  }}
                                >
                                  {m.UpcomingPTO[1]} - {m.UpcomingPTO[2]}
                                </td>
                                <td className="col-md-2 mt-2 healthcare-last-updated">
                                  {m.LastUpdated}
                                </td>
                                {(m.TableDeals.length > 0 && toggled) ? (
                                  <td className="col-md-2 mt-2">

                                  {(!toggled?.filter(t => t.UserID == m.UserID)[0] ? false : toggled?.filter(t => t.UserID == m.UserID)[0].Toggled) ? (
                                    <div className="healthcare-button-row">
                                      <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Edit {m.DealsTaskName}</Tooltip>}
                                      >
                                          {redirectToEdit(m)}
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Expand {m.DealsTaskName}</Tooltip>}
                                      >
                                      <img
                                        alt="dropdown-arrow"
                                        src={DashboardExpand}
                                        onClick = {(e) =>{
                                          showDealsModal(m)
                                        }}
                                      />
                                      </OverlayTrigger>
                                      <img
                                        disabled = {juniorBankerView}
                                        alt="dropdown-arrow"
                                        src={DropdownUpArrow}
                                        onClick={(e) => {
                                          if(m.TableDeals.length > 0){
                                            let updatedToggled = toggled?.map((t) => {
                                              if(t.UserID == m.UserID){
                                                t.Toggled = false;
                                              }
                                              return t;
                                            });
                                            toggleAccordion(accordionId + "-" + m.UserID);
                                            setToggled(updatedToggled)
                                            setCollapsed(getCollapsedStatus(accordionId));
                                          }
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div className="healthcare-button-row">
                                      <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Edit {m.DealsTaskName}</Tooltip>}
                                      >
                                          {redirectToEdit(m)}
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Expand {m.DealsTaskName}</Tooltip>}
                                      >
                                      <img
                                        alt="dropdown-arrow"
                                        src={DashboardExpand}
                                        onClick = {(e) =>{
                                          showDealsModal(m)
                                        }}
                                      />
                                      </OverlayTrigger>

                                      <img
                                        disabled = {juniorBankerView}
                                        className="dropdown-arrow"
                                        alt="dropdown-arrow"
                                        src={DropdownArrow}
                                        onClick={(e) => {
                                          if(m.TableDeals.length > 0 && !juniorBankerView){
                                            let updatedToggled = toggled?.map((t) => {
                                              if(t.UserID == m.UserID){
                                                t.Toggled = true;
                                              }
                                              return t;
                                            });
                                            toggleAccordion(accordionId + "-" + m.UserID);
                                            setToggled(updatedToggled)
                                            setCollapsed(getCollapsedStatus(accordionId))
                                          }
                                        }}
                                      />
                                    </div>
                                  )}

                                  </td>
                                ) : (
                                  <td className="col-md-2 mt-2">
                                    <div className="healthcare-button-row">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Edit {m.DealsTaskName}</Tooltip>}
                                      >
                                        {redirectToEdit(m)}
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Expand {m.DealsTaskName}</Tooltip>}
                                      >
                                      <img
                                      disabled
                                        alt="dropdown-arrow"
                                        src={DashboardExpand}
                                      />
                                      </OverlayTrigger>
                                      <img
                                        disabled
                                        alt="dropdown-arrow"
                                        src={DropdownArrow}
                                      />
                                    </div>
                                  </td>
                                )}
                              </div>

                              {/* Dropdown For Deals Tables */}
                              <Accordion.Collapse
                                eventKey={m.UserID}
                                scrollable={true}
                                className={"scrollable-dashboard " + accordionId}
                                id={accordionId + "-" + m.UserID}
                              >
                                <Card.Body
                                  scrollable={true}
                                >
                                  {renderTableHealthcare(m.TableDeals, true)}
                                </Card.Body>
                              </Accordion.Collapse>                                                        
                            </Card>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </Accordion>
            </div>
          </table>
        </div>
         {seletedMember && (
            <Modal
              key={seletedMember.UserID}
              show={show}
              onHide={onHide}
              contentClassName="deal-and-vacation-date-healthcare-modal-styles"
              dialogClassName="deal-and-vacation-date-healthcare-modal"
              backdropClassName="healthcare-modal-backdrop"
              scrollable={true}
            >
              <div className="popup-week healthcare-deal">
                <Modal.Header
                  className="header-popup"
                  closeButton
                >
                  <div className="healthcare-deal-task-name">
                    Next Protected Weekend and Upcoming PTO
                    <div className="healthcare-deal-user-name">
                      {seletedMember.Name}
                    </div>
                  </div>
                </Modal.Header>
                <hr></hr>
                {seletedMember.AllowVacationsEdit && <div className="healthcare-edit-button-container">
                    <div>
                    <Link to={`/tasks/edit/std/${seletedMember.VacationsTaskId}`} target="_blank"  rel='noopener noreferrer'>
                      <div className="healthcare-edit">
                          <img
                        alt="dropdown-arrow"
                        src={DashboardEdit}
                        />
                        Edit Table
                      </div>
                
                    </Link>
                    </div>
                  </div>}
                <Modal.Body className="header-body">
                {renderTableVacation(
                    seletedMember.TableVacation
                  )}
                </Modal.Body>
              </div>
            </Modal>
          )}   
        {/* Expand Deals Table */}
        {seletedMember && (
        <Modal
          key={seletedMember.UserID}
          show={showDeals}
          onHide={() => setShowDeals(false)}
          contentClassName="deal-and-vacation-date-healthcare-modal-styles"
          dialogClassName="deal-and-vacation-date-healthcare-modal"
          backdropClassName="healthcare-modal-backdrop"
          scrollable={true}
        >
          <div className="popup-week healthcare-deal">
            <Modal.Header
              className="header-popup"
              closeButton
            >
              <div className="healthcare-deal-task-name">
                Project, Deals, and Vacation Tracker
                <div className="healthcare-deal-user-name">
                  {seletedMember.Name}
                </div>
              </div>
            </Modal.Header>
            <hr></hr>
            {seletedMember.AllowDealsEdit && <div className="healthcare-edit-button-container">
                <div >
                <Link to={`/tasks/edit/std/${seletedMember.DealsTaskId}`} target="_blank"  rel='noopener noreferrer'>
                  <div className="healthcare-edit">
                      <img
                    alt="dropdown-arrow"
                    src={DashboardEdit}
                    />
                    Edit Table
                  </div>
                </Link>
                </div>
              </div>}
            <Modal.Body className="header-body">
              {renderTableHealthcare(
                seletedMember.TableDeals
              )}
            </Modal.Body>
          </div>
        </Modal>
      )}
      </div>
    );
  }
  return null;
};

DashboardHealthcare.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  currSubDepartment: PropTypes.string,
};

export default DashboardHealthcare;
